import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface MockPartnerNotificationProps extends BaseTemplateProps {}

export const MockPartnerNotification: TemplateDefinition<MockPartnerNotificationProps> = {
  renderParams: (props: MockPartnerNotificationProps) => ({
    messageKey: 'notificationsDomain.templates.mockPartnerNotification',
    values: {
      givenName: props.givenName,
      surname: props.surname,
    },
  }),
}
